import { render, staticRenderFns } from "./SuppliersTable.vue?vue&type=template&id=504eb6ec&scoped=true&"
import script from "./SuppliersTable.vue?vue&type=script&lang=js&"
export * from "./SuppliersTable.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersTable.vue?vue&type=style&index=0&id=504eb6ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504eb6ec",
  null
  
)

export default component.exports